import { render, staticRenderFns } from "./DevisTypesBARSE.vue?vue&type=template&id=39d91c6a&scoped=true"
import script from "./DevisTypesBARSE.vue?vue&type=script&lang=js"
export * from "./DevisTypesBARSE.vue?vue&type=script&lang=js"
import style0 from "./DevisTypesBARSE.vue?vue&type=style&index=0&id=39d91c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d91c6a",
  null
  
)

export default component.exports